export const PLACEHOLDER = 'O que você procura na Leroy Merlin?';
export const PRODUCTS_AND_SERVICES_PLACEHOLDER =
  'De Produtos a Serviços: Digite o que você precisa';
